import {Directive, ElementRef, Input, OnChanges, Renderer2} from "@angular/core";

@Directive({
	selector: '[show]',
})
export class ShowDirective implements OnChanges {
	@Input() show: boolean;

	constructor(private renderer: Renderer2, private elRef: ElementRef) {}

	ngOnChanges() {
		if (this.show) {
			this.renderer.setStyle(this.elRef.nativeElement, 'display', 'block');
		} else {
			this.renderer.setStyle(this.elRef.nativeElement, 'display', 'none');
		}
	}
}
